import React from "react";

const ProductItemLoader: React.FC = () => {
  return (
    <article className="w-full flex flex-col cursor-pointer max-w-[300px]">
      <figure
        className="w-full rounded-15 overflow-hidden bg-grey-loader animate-pulse"
        style={{ paddingTop: "100%" }}
      ></figure>
      <div className="mt-2 flex flex-col justify-between flex-1">
        <h5 className="w-40 h-3.5 bg-grey-loader animate-pulse rounded-15"></h5>
        <div className="flex w-full items-center justify-between mt-2">
          <span className="bg-grey-loader w-25 h-2.5 animate-pulse rounded-15"></span>
        </div>
      </div>
    </article>
  );
};

export default ProductItemLoader;
